module.exports = __webpack_public_path__ + "img/kefu.d40c0249.jpg";